module.exports = __webpack_public_path__ + "static/img/znkj.ff5efd07.jpg";